// apps/lc/src/mocks/wireframe/performance.ts
import type { PerformanceMonth } from './types'

// 2025-06 .. 2026-05 (12 months ending at today())
function makeMonths(): PerformanceMonth[] {
  const out: PerformanceMonth[] = []
  for (let i = 0; i < 12; i++) {
    const year = i < 7 ? 2025 : 2026
    const monthNum = i < 7 ? 6 + i : i - 7 + 1
    const month = `${year}-${String(monthNum).padStart(2, '0')}`
    const base = 8 + Math.round(Math.sin(i / 2) * 3)
    const active = base
    const onLeave = i % 4 === 0 ? 1 : 0
    const pending = i % 3 === 0 ? 2 : 1
    const revenue = active * 350000 + (i * 20000)
    const fee = Math.round(revenue * 0.18)
    out.push({ month, activeStudents: active, onLeaveStudents: onLeave, pendingStudents: pending, revenue, fee })
  }
  return out
}

export const PERFORMANCE: PerformanceMonth[] = makeMonths()
